/**
 * Sessão e respostas genéricas do modo mock (REACT_APP_MOCK=true).
 *
 * Serve para navegar pelas telas de Pipelines sem backend — usado para gerar as
 * capturas de tela da proposta. Fora do modo mock nada aqui é carregado.
 */

const minutesAgo = n => new Date(Date.now() - n * 60000).toISOString();

const ALL_PERMISSIONS = [
    "view_unrelated_dashboard", "view_related_dashboard",
    "view_product", "view_color", "view_category", "view_tag", "view_customization",
    "view_unrelated_budget", "view_related_budget",
    "view_unrelated_order", "view_related_order",
    "view_unrelated_customer", "view_related_customer",
    "view_unrelated_order_commission", "view_related_order_commission",
    "content", "admin", "role",
    "calculation", "status", "email_template", "site",
    "edit_crm_settings", "manage_pipelines",
].map((name, id) => ({ id: id + 1, name }));

export const MOCK_USER = {
    id: 1,
    name: "Fernanda Borelli",
    email: "fernanda@starbrindes.com.br",
    photo_url: null,
    role: {
        id: 1,
        name: "Administrador",
        permissions: ALL_PERMISSIONS,
    },
};

// Usuários devolvidos por GET /list (selects de responsável / membros).
export const ADMIN_LIST_RESPONSE = {
    resources: [
        { id: 1, name: "Marina Souza", email: "marina@starbrindes.com.br", photo_url: null },
        { id: 2, name: "Carlos Mendes", email: "carlos@starbrindes.com.br", photo_url: null },
        { id: 3, name: "Ana Beatriz Costa", email: "ana@starbrindes.com.br", photo_url: null },
        { id: 4, name: "Rafael Almeida", email: "rafael@starbrindes.com.br", photo_url: null },
        { id: 5, name: "Juliana Ribeiro", email: "juliana@starbrindes.com.br", photo_url: null },
        { id: 6, name: "Pedro Henrique Lima", email: "pedro@starbrindes.com.br", photo_url: null },
    ],
};

export const BUDGET_COUNT_RESPONSE = { count: 4 };

// Sino de notificações — menções em cards do CRM. As três primeiras ficam sem
// `read_at` para a captura sair com o badge "3" e os itens destacados.
export const MENTION_NOTIFICATIONS_RESPONSE = {
    unread_count: 3,
    resources: [
        {
            id: 1,
            mentioned_by: "Carlos Mendes",
            card_id: 6,
            card_code: "8814",
            excerpt: "O cliente falou que quer conversar com você antes de fechar. Consegue ligar hoje à tarde?",
            created_at: minutesAgo(8),
            read_at: null,
        },
        {
            id: 2,
            mentioned_by: "Ana Beatriz Costa",
            card_id: 12,
            card_code: "8788",
            excerpt: "Aprovaram a amostra virtual. Pode preparar o contrato que eles querem fechar esta semana.",
            created_at: minutesAgo(52),
            read_at: null,
        },
        {
            id: 3,
            mentioned_by: "Rafael Almeida",
            card_id: 4,
            card_code: "8834",
            excerpt: "Cliente comparou com outro fornecedor e pediu uma condição melhor. Consigo cobrir?",
            created_at: minutesAgo(3 * 60),
            read_at: null,
        },
        {
            id: 4,
            mentioned_by: "Juliana Ribeiro",
            card_id: 5,
            card_code: "8831",
            excerpt: "Orçamento revisado enviado. Combinei retorno para segunda.",
            created_at: minutesAgo(26 * 60),
            read_at: minutesAgo(24 * 60),
        },
    ],
};
